module.exports = __webpack_public_path__ + "img/s7.877800a.png";